/**
 * @generated SignedSource<<ac4c25a007a4d63b91bfc4905850c1f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationPushAppyCreateScreenMutation$variables = {
  link: string;
};
export type IntegrationPushAppyCreateScreenMutation$data = {
  readonly store: {
    readonly activateIntegrationPushAppy: boolean | null;
  };
};
export type IntegrationPushAppyCreateScreenMutation = {
  response: IntegrationPushAppyCreateScreenMutation$data;
  variables: IntegrationPushAppyCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "link"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "link",
            "variableName": "link"
          }
        ],
        "kind": "ScalarField",
        "name": "activateIntegrationPushAppy",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationPushAppyCreateScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationPushAppyCreateScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "210c9719332c65b1ef33195656dab1d7",
    "id": null,
    "metadata": {},
    "name": "IntegrationPushAppyCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationPushAppyCreateScreenMutation(\n  $link: String!\n) {\n  store {\n    activateIntegrationPushAppy(link: $link)\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d5c05217009cffb400c925cdd195229";

export default node;
